var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('aside', {
    staticClass: "sidebar hide-on-large-only",
    attrs: {
      "id": "leftsidebar"
    }
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/user.png'),
      "width": "48",
      "height": "48",
      "alt": "User"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-container"
  }, [_c('div', {
    staticClass: "name",
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.namaLengkap))]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("MAIN NAVIGATION")]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.link == 'main/dashboard'
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/dashboard')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("home")]), _vm._v(" "), _c('span', [_vm._v("Home")])])]), _vm._v(" "), (_vm.akses.masterNarasumber) ? _c('li', {
    class: {
      'active': _vm.link == 'main/narasumber'
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    on: {
      "click": function($event) {
        _vm.$router.push('/main/narasumber')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("assignment")]), _vm._v(" "), _c('span', [_vm._v("Master Narasumber")])])]) : _vm._e(), _vm._v(" "), (_vm.akses.userLevel) ? _c('li', {
    class: {
      'active': _vm.link == 'main/admin'
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    on: {
      "click": function($event) {
        _vm.$router.push('/main/admin')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("https")]), _vm._v(" "), _c('span', [_vm._v("User Level")])])]) : _vm._e(), _vm._v(" "), (_vm.akses.anggota) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/anggota'
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    on: {
      "click": function($event) {
        _vm.$router.push('/main/anggota')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("person")]), _c('span', [_vm._v("Data Anggota")])])]) : _vm._e(), _vm._v(" "), (_vm.aksesProfile) ? _c('li', {
    class: {
      active: _vm.isProfile
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "menu-toggle",
    class: {
      toggled: _vm.isProfile
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.isProfile = !_vm.isProfile
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("assignment")]), _vm._v(" "), _c('span', [_vm._v("Profile")])]), _vm._v(" "), _c('ul', {
    staticClass: "ml-menu",
    class: {
      show: _vm.isProfile
    }
  }, [(_vm.akses.profile.visi_misi) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/profile/visi-misi'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/profile/visi-misi'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/profile/visi-misi')
      }
    }
  }, [_vm._v("Visi Misi")])]) : _vm._e(), _vm._v(" "), (_vm.akses.profile.sejarah_pendirian) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/profile/sejarah'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/profile/sejarah'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/profile/sejarah')
      }
    }
  }, [_vm._v("Sejarah Pendirian")])]) : _vm._e(), _vm._v(" "), (_vm.akses.profile.pendiri) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/profile/pendiri'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/profile/pendiri'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/profile/pendiri')
      }
    }
  }, [_vm._v("Pendiri")])]) : _vm._e(), _vm._v(" "), (_vm.akses.profile.dewan_pengawas) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/profile/dewan-pengawas'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/profile/dewan-pengawas'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/profile/dewan-pengawas')
      }
    }
  }, [_vm._v("Dewan Pengawas")])]) : _vm._e(), _vm._v(" "), (_vm.akses.profile.pengurus) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/profile/pengurus'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/profile/pengurus'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/profile/pengurus')
      }
    }
  }, [_vm._v("Pengurus")])]) : _vm._e(), _vm._v(" "), (_vm.akses.profile.struktur_organisasi) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/profile/struktur-organisasi'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/profile/struktur-organisasi'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/profile/struktur-organisasi')
      }
    }
  }, [_vm._v("Struktur Organisasi")])]) : _vm._e(), _vm._v(" "), (_vm.akses.profile.budaya_kerja) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/profile/budaya-kerja'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/profile/budaya-kerja'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/profile/budaya-kerja')
      }
    }
  }, [_vm._v("Budaya Kerja")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.aksesLayanan) ? _c('li', {
    class: {
      active: _vm.isLayanan
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "menu-toggle",
    class: {
      toggled: _vm.isLayanan
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.isLayanan = !_vm.isLayanan
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("content_copy")]), _vm._v(" "), _c('span', [_vm._v("Layanan")])]), _vm._v(" "), _c('ul', {
    staticClass: "ml-menu",
    class: {
      show: _vm.isLayanan
    }
  }, [(_vm.akses.layanan.cetak_mp) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/layanan/cetakMP'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/layanan/cetakMP'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/layanan/cetakMP')
      }
    }
  }, [_vm._v("Cetak Struk MP/Pajak")])]) : _vm._e(), _vm._v(" "), (_vm.akses.layanan.cetak_up) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/layanan/cetak-struk-uang-pembinaan'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/layanan/cetak-struk-uang-pembinaan'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/layanan/cetak-struk-uang-pembinaan')
      }
    }
  }, [_vm._v("Cetak Struk Uang Pembinaan")])]) : _vm._e(), _vm._v(" "), (_vm.akses.layanan.cetak_rapel) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/layanan/cetak-struk-rapel'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/layanan/cetak-struk-rapel'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/layanan/cetak-struk-rapel')
      }
    }
  }, [_vm._v("Cetak Struk Rapel Kenaikan")])]) : _vm._e(), _vm._v(" "), (_vm.akses.layanan.cetak_spt) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/layanan/cetak-spt'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/layanan/cetak-spt'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/layanan/cetak-spt')
      }
    }
  }, [_vm._v("Cetak SPT")])]) : _vm._e(), _vm._v(" "), (_vm.akses.layanan.atur_ip) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/layanan/atur-ip'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/layanan/atur-ip'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/layanan/atur-ip')
      }
    }
  }, [_vm._v("Atur Identitas Pemotong")])]) : _vm._e(), _vm._v(" "), (_vm.akses.layanan.survey) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/layanan/survey'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/layanan/survey'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/layanan/survey')
      }
    }
  }, [_vm._v("Survey Pelayanan Pensiun")])]) : _vm._e(), _vm._v(" "), (_vm.akses.layanan.hasil_survey) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/layanan/survey/hasil'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/layanan/survey/hasil'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/layanan/survey/hasil')
      }
    }
  }, [_vm._v("Hasil Survey Pelayanan Pensiun")])]) : _vm._e(), _vm._v(" "), (_vm.akses.layanan.data_kelengkapan) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/layanan/kelengkapan'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/layanan/kelengkapan'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/layanan/kelengkapan')
      }
    }
  }, [_vm._v("Data Daftar Kelengkapan")])]) : _vm._e(), _vm._v(" "), (_vm.akses.layanan.data_kelengkapan) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/layanan/KritikdanSaran'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/layanan/KritikDanSaran'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/layanan/KritikDanSaran')
      }
    }
  }, [_vm._v("Kritik")])]) : _vm._e(), _vm._v(" "), (_vm.akses.layanan.data_kelengkapan) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/layanan/Pengaduan'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/layanan/Pengaduan'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/layanan/Pengaduan/')
      }
    }
  }, [_vm._v("Pengaduan")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.aksesInformasi) ? _c('li', {
    class: {
      active: _vm.isInformasi
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "menu-toggle",
    class: {
      toggled: _vm.isInformasi
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.isInformasi = !_vm.isInformasi
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("assignment")]), _vm._v(" "), _c('span', [_vm._v("Informasi")])]), _vm._v(" "), _c('ul', {
    staticClass: "ml-menu",
    class: {
      show: _vm.isInformasi
    }
  }, [(_vm.akses.informasi.kegiatan) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/informasi/kegiatan'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/informasi/kegiatan'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/informasi/kegiatan')
      }
    }
  }, [_vm._v("Kegiatan")])]) : _vm._e(), _vm._v(" "), (_vm.akses.informasi.artikel) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/informasi/artikel'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/informasi/artikel'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/informasi/artikel')
      }
    }
  }, [_vm._v("Artikel")])]) : _vm._e(), _vm._v(" "), (_vm.akses.informasi.perkembangan) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/informasi/perkembangan'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/informasi/perkembangan'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/informasi/perkembangan')
      }
    }
  }, [_vm._v("Perkembangan Investasi Semesteran")])]) : _vm._e(), _vm._v(" "), (_vm.akses.informasi.tahunan) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/informasi/tahunan'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/informasi/tahunan'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/informasi/tahunan')
      }
    }
  }, [_vm._v("Laporan Keuangan")])]) : _vm._e(), _vm._v(" "), (_vm.akses.informasi.lowongan) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/informasi/lowongan'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/informasi/lowongan'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/informasi/lowongan')
      }
    }
  }, [_vm._v("Lowongan")])]) : _vm._e(), _vm._v(" "), (_vm.akses.informasi.galeri) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/informasi/galeri'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/informasi/galeri'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/informasi/galeri')
      }
    }
  }, [_vm._v("Galeri")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.aksesUnduh) ? _c('li', {
    class: {
      active: _vm.isUnduh
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "menu-toggle",
    class: {
      toggled: _vm.isUnduh
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.isUnduh = !_vm.isUnduh
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_download")]), _vm._v(" "), _c('span', [_vm._v("Unduh")])]), _vm._v(" "), _c('ul', {
    staticClass: "ml-menu",
    class: {
      show: _vm.isUnduh
    }
  }, [(_vm.akses.unduh.pdp) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/unduh/pdp'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/unduh/pdp'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/unduh/pdp')
      }
    }
  }, [_vm._v("PDP")])]) : _vm._e(), _vm._v(" "), (_vm.akses.unduh.arahan) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/unduh/arahan'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/unduh/arahan'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/unduh/arahan')
      }
    }
  }, [_vm._v("Arahan")])]) : _vm._e(), _vm._v(" "), (_vm.akses.unduh.regulasi) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/unduh/regulasi'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/unduh/regulasi'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/unduh/regulasi')
      }
    }
  }, [_vm._v("Regulasi Dana Pensiun")])]) : _vm._e(), _vm._v(" "), (_vm.akses.unduh.majalah) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/unduh/majalah'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/unduh/majalah'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/unduh/majalah')
      }
    }
  }, [_vm._v("Booklet Dapenbi")])]) : _vm._e(), _vm._v(" "), (_vm.akses.unduh.materikomunikasi) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/unduh/materiKomunikasi'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/unduh/materiKomunikasi'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/unduh/materiKomunikasi')
      }
    }
  }, [_vm._v("Materi Komunikasi")])]) : _vm._e(), _vm._v(" "), (_vm.akses.unduh.laporan) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/unduh/laporan'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/unduh/laporan'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/unduh/laporan')
      }
    }
  }, [_vm._v("Laporan Tahunan dan Pengawasan")])]) : _vm._e(), _vm._v(" "), (_vm.akses.unduh.formulir) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/unduh/formulir'
    }
  }, [_c('a', {
    class: {
      toggled: _vm.fullLink === 'main/unduh/formulir'
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/main/unduh/formulir')
      }
    }
  }, [_vm._v("Formulir Kepesertaan dan Pelayanan Pensiun")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "menu-toggle",
    class: {
      toggled: _vm.isPensiunRegistrasi
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.isPensiunRegistrasi = !_vm.isPensiunRegistrasi
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_download")]), _vm._v(" "), _c('span', [_vm._v("Pensiun Registrasi")])]), _vm._v(" "), _c('ul', {
    staticClass: "ml-menu",
    class: {
      show: _vm.isPensiunRegistrasi
    }
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.$router.push('/main/pensiunRegistrasi/pensiuntype')
      }
    }
  }, [_vm._v("ListPensiun type")])])])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "menu-toggle",
    class: {
      toggled: _vm.isFaq
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.isFaq = !_vm.isFaq
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("question_answer")]), _vm._v(" "), _c('span', [_vm._v("FAQ")])]), _vm._v(" "), _c('ul', {
    staticClass: "ml-menu",
    class: {
      show: _vm.isFaq
    }
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.$router.push('/main/faq')
      }
    }
  }, [_vm._v(" FAQ")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.$router.push('/main/faq/Categoryfaq')
      }
    }
  }, [_vm._v("List FAQ Category")])])])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    on: {
      "click": function($event) {
        _vm.$router.push('/main/pengumuman/pengumuman')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("announcement")]), _vm._v(" "), _c('span', [_vm._v("Pengumuman")])])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    on: {
      "click": function($event) {
        _vm.$router.push('/main/calender')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("announcement")]), _vm._v(" "), _c('span', [_vm._v("Kalender")])])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    on: {
      "click": function($event) {
        _vm.$router.push('/main/banner')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("announcement")]), _vm._v(" "), _c('span', [_vm._v("Banner")])])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    on: {
      "click": function($event) {
        _vm.$router.push('/main/HakdanWajiban/ListHakdanKewajiban')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("announcement")]), _vm._v(" "), _c('span', [_vm._v("Hak dan Kewajiban Peserta")])])]), _vm._v(" "), (_vm.akses.log) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/log'
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    on: {
      "click": function($event) {
        _vm.$router.push('/main/log')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("assignment")]), _vm._v(" "), _c('span', [_vm._v("Log")])])]) : _vm._e(), _vm._v(" "), (_vm.akses.syarat) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/syarat'
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    on: {
      "click": function($event) {
        _vm.$router.push('/main/syarat')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("collections_bookmark")]), _vm._v(" "), _c('span', [_vm._v("Syarat Kepesertaan")])])]) : _vm._e(), _vm._v(" "), (_vm.akses.cara) ? _c('li', {
    class: {
      active: _vm.fullLink === 'main/cara'
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    on: {
      "click": function($event) {
        _vm.$router.push('/main/cara')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("accessibility")]), _vm._v(" "), _c('span', [_vm._v("Cara Mendaftar")])])]) : _vm._e(), _vm._v(" "), (_vm.akses.slider) ? _c('li', {
    class: {
      'active': _vm.link == 'main/slider'
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    on: {
      "click": function($event) {
        _vm.$router.push('/main/slider')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("photo_library")]), _c('span', [_vm._v("Slider")])])]) : _vm._e(), _vm._v(" "), (_vm.akses.kirimNotifikasi) ? _c('li', {
    class: {
      'active': _vm.link == 'main/notification'
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    on: {
      "click": function($event) {
        _vm.$router.push('/main/notification')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("notifications")]), _c('span', [_vm._v("Kirim Notifikasi")])])]) : _vm._e(), _vm._v(" "), (_vm.akses.headline) ? _c('li', {
    class: {
      'active': _vm.link == 'main/headline'
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    on: {
      "click": function($event) {
        _vm.$router.push('/main/headline')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("info_outline")]), _c('span', [_vm._v("Headline")])])]) : _vm._e(), _vm._v(" "), (_vm.akses.whistleBlower) ? _c('li', {
    class: {
      'active': _vm.link == 'main/whistleblower'
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    on: {
      "click": function($event) {
        _vm.$router.push('/main/whistleblower')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("message")]), _vm._v(" "), _c('span', [_vm._v("WhistleBlower")])])]) : _vm._e(), _vm._v(" "), (_vm.akses.anakPerusahaan) ? _c('li', {
    class: {
      'active': _vm.link == 'main/anak-perusahaan'
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    on: {
      "click": function($event) {
        _vm.$router.push('/main/anak-perusahaan')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("library_books")]), _c('span', [_vm._v("Company & Anak Perusahaan")])])]) : _vm._e(), _vm._v(" "), (_vm.akses.hubungiKami) ? _c('li', {
    class: {
      'active': _vm.link == 'main/hubungi-kami'
    }
  }, [_c('a', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    on: {
      "click": function($event) {
        _vm.$router.push('/main/hubungi-kami')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("local_phone")]), _vm._v(" "), _c('span', [_vm._v("Hubungi Kami")])])]) : _vm._e()])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group user-helper-dropdown"
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "true"
    }
  }, [_vm._v("keyboard_arrow_down")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("person")]), _vm._v("Profile")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "seperator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("input")]), _vm._v("Sign Out")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6f55dec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = CbXV
// module chunks = 1